import React, { createContext, useContext, useState, useCallback } from 'react';
import { queryClient } from './lib/queryClient';

const ComplianceContext = createContext();

export function ComplianceProvider({ children }) {
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const triggerRefresh = useCallback(() => {
        setRefreshTrigger(prev => prev + 1);
        // Wave 1 Stage C: this bus is fired by components that write via raw
        // fetch() (EnhancedControlDetail, Evidence) and therefore bypass the
        // axios cache-invalidation interceptors. Invalidate the compliance
        // query families here so cached pages can never go stale after those
        // writes either.
        ['dashboard', 'controls', 'policies', 'vault'].forEach((k) => {
            try { queryClient.invalidateQueries({ queryKey: [k] }); } catch { /* noop */ }
        });
    }, []);

    return (
        <ComplianceContext.Provider value={{ refreshTrigger, triggerRefresh }}>
            {children}
        </ComplianceContext.Provider>
    );
}

export function useCompliance() {
    return useContext(ComplianceContext);
}
